import { Injectable } from '@angular/core'
import { Apollo } from 'apollo-angular'
import gql from 'graphql-tag'
import { DocumentNode } from 'apollo-link'
import { ApolloQueryResult } from 'apollo-client'
import { Observable } from 'rxjs'

interface Data {
  currentUser: User
}

export interface User {
  id: number
  writer: Writer
  canCreateWriterGoal: boolean
}

export interface WriterGoal {
  id: number
  goalWords: number
  writtenWords: number
}

export interface Writer {
  id: number
  publishProfile: boolean
  slug: string
  firstName: string
  points: number
  nextLevelPoints: number
  level: number
  declineRate: number
  soldCount: number
  declineCount: number
  currentEarnings: number
  invoicedEarnings: number
  pendingEarnings: number
  futureEarnings: number
  inactive: boolean
  state: string
  canToggleUnavailable: boolean
  currentWriterGoals: WriterGoal
}

export const writerFragment = gql`
  fragment WriterProfileSummaryWriterFragment on Writer {
    id
    publishProfile
    slug
    firstName
    points
    nextLevelPoints
    level
    declineRate
    soldCount
    declineCount
    currentEarnings
    invoicedEarnings
    pendingEarnings
    futureEarnings
    inactive
    state
    canToggleUnavailable: can(action: "toggle_unavailable")
    currentWriterGoals {
      id
      goalWords
      writtenWords
    }
  }
`

const query: DocumentNode = gql`
  query WriterProfileSummary {
    currentUser {
      id
      writer {
        ...WriterProfileSummaryWriterFragment
      }
      canCreateWriterGoal: can(action: "create", subject: "WriterGoal")
    }
  }
  ${writerFragment}
`


@Injectable({providedIn: 'root'})
export class WriterProfileSummaryQueries {
  constructor(private apollo: Apollo) {}

  writerProfileSummary(): Observable<ApolloQueryResult<Data>> {
    return this.apollo.watchQuery<Data>({
      query,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network'
    }).valueChanges
  }
}
